/**
 * Takip Sorgula paketi kapanınca inen "Excel Sonuçlar" dosyası için kararlar.
 *
 * (1) SENKRON PAKETİNDE İNDİRME YOK: gece koşumunda kimse başında değil; imza
 *     kabuğu her indirme için yerel kayıt penceresi açıyor (zirvelib'de sessiz
 *     kayıt API'si yok), pencere kabuğu bloke ediyor, tamamlanma sesi ilk notada
 *     kesiliyor ve pencereler sabaha kadar birikiyordu (8 Eyl). Sonuçlar zaten
 *     sunucu snapshot deposunda; Excel tarayıcıdaki görev detayından alınır.
 *     Senkron paketi = `scheduled_at` dolu (sunucudaki tanımla aynı).
 * (2) ZAMAN DAMGALI AD: aynı adla ikinci indirme "(1)" eki ya da üzerine yazma
 *     sorusu doğuruyordu. Ad İstanbul saatiyle "Sorgu Sonuçları 2026-09-08 10-12.xlsx";
 *     ':' Windows'ta dosya adında yasak, '-' kullanılır.
 */
export function sorguExceliIndirilmeliMi(task: {scheduled_at?: unknown} | null | undefined): boolean {
    if (!task) {
        return false;
    }
    const s = task.scheduled_at;
    return s === null || s === undefined || s === "";
}

export function sorguExcelDosyaAdi(simdi: Date = new Date()): string {
    const secenekler: any = {
        timeZone: "Europe/Istanbul",
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", hour12: false
    };
    // tr-TR: "08.09.2026 10:12" → parçalar sabit sırada gelir.
    const m = new Intl.DateTimeFormat("tr-TR", secenekler).format(simdi)
        .match(/(\d{2})\.(\d{2})\.(\d{4})\D+(\d{2}):(\d{2})/);
    if (!m) {
        return "Sorgu Sonuçları.xlsx";
    }
    const [, gun, ay, yil, saat, dk] = m;
    return `Sorgu Sonuçları ${yil}-${ay}-${gun} ${saat}-${dk}.xlsx`;
}
